import { render, staticRenderFns } from "./CheckoutComponent.vue?vue&type=template&id=71b72402"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutComponent.vue
// module id = null
// module chunks = 